import Exception from '@/pages/exception'

export default () => <Exception code="404" />
